@if (mapPoint) {
  <div class="map-point-popup">
    @if (mapPoint.name) {
      <div id="popupName" class="name helper-truncate">
        {{ mapPoint.name | localeNumberCoordinateFormat }}
      </div>
    }
    @if (isRidePlanning$ | async) {
      <rdx-planned-ride-stop
        [mapPoint]="mapPoint"
        (addMapPointToPlannedRide)="addMapPointToPlannedRide.emit(mapPoint)"
        (removeMapPointFromPlannedRide)="removeMapPointFromPlannedRide.emit($event)"
      />
    }
  </div>
}
